import { defineStore } from 'pinia'
import api from '@/modules/essentialShop/api'
import helpers from '@/modules/message/helpers'
import { t } from '@/plugins/i18n.ts'

interface ProductRequestState {
  sending: boolean
}

const initialState = (): ProductRequestState => {
  return {
    sending: false
  }
}

const useEssentialShopActivationRequest = defineStore('essentialShopActivationRequest', {
  state: () => initialState(),
  actions: {
    async sendEssentialShopActivationRequest(emailAddress: string) {
      this.sending = true

      return api
        .sendEssentialShopActivationRequest(emailAddress)
        .then(() => helpers.reportSuccess(t('success.essentialShopActivationRequested')))
        .catch(() => {
          helpers.reportError(t('error.essentialShopActivationRequested'))
        })
        .finally(() => {
          this.sending = false
        })
    }
  }
})

export default useEssentialShopActivationRequest
